import * as API from "utils/api"
import { APIResponse } from "./types"

/**
 * ランキング
 */
const Ranking: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/Ranking", params, headers)
}

/**
 * 銘柄リストシート一覧
 */
const SymbolSheetList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SymbolSheetList",
    params,
    headers
  )
}

const GetRealSymbolSheetList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/GetRealSymbolSheetList",
    params,
    headers
  )
}

/**
 * 銘柄リスト詳細
 */
const SymbolSheet: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/SymbolSheet", params, headers)
}

/**
 * 銘柄シート編集
 */
const EditSymbolSheet: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  const EditSymbolSheet = await API.auth_request(
    "POST",
    "Message/EditSymbolSheet",
    params,
    headers
  )
  //todo エラー時のnotification機能
  //   .catch(err => {
  //   notification("D010101-003")
  //   throw err
  // })
  return EditSymbolSheet
}

/**
 * 株価お知らせ
 */
const RegisterTriggerMail: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "POST",
    "Equity/Message/RegisterTriggerMail",
    params,
    headers
  )
}

const GetTriggerMail: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetTriggerMail",
    params,
    headers
  )
}

const CancelTriggerMail: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "POST",
    "Equity/Message/CancelTriggerMail",
    params,
    headers
  )
}

/**
 * スクリーニング
 */
const Screening: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("POST", "Message/Screening", params, headers)
}

/**
 * 株主優待検索
 */
const StockholderBenefit: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "POST",
    "Message/StockholderBenefit",
    params,
    headers
  )
}

/**
 * 統計情報
 */
const DivisionStatistics: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/DivisionStatistics",
    params,
    headers
  )
}

/**
 * 騰落レシオ
 */
const DivisionChangedRatio: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/DivisionChangedRatio",
    params,
    headers
  )
}

/**
 * 新値銘柄
 */
const NewPriceSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/NewPriceSymbol",
    params,
    headers
  )
}

/**
 * 特別気配銘柄
 */
const SpecialQuoteSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/SpecialQuoteSymbol",
    params,
    headers
  )
}

/**
 * テーマ取得
 */
const GetTheme: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetTheme",
    {
      ...params,
      ...{
        _select:
          "ChangedRatio" +
          ",Description" +
          ",ID" +
          ",IsDelay" +
          ",Key" +
          ",Keyword" +
          ",Name" +
          ",ThemeImages" +
          ",ThemeSymbolSecurityTypesCount" +
          ",ThemeIncreseRanking" +
          ",ThemeRanking" +
          ",ThemeRelations" +
          ",ThemeSymbolsCount",
      },
    },
    headers
  )
}

/**
 * テーマ取得
 */
const GetThemeSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetThemeSymbolList",
    params,
    headers
  )
}

/**
 * キーワード検索
 */
const SearchSymbolKeywords: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "POST",
    "Equity/Message/SearchSymbolKeywords",
    params,
    headers
  )
}

const GetSSOUrl: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/GetSSOUrl", params, headers)
}

const SpecificAccountPLDetailDownload: API.RequestAPI<
  APIResponse.Res | {}
> = async (params?: object) => {
  return API.auth_request(
    "GET",
    "Equity/FileCsv/SpecificAccountPLDetailDownload",
    params
  )
}

const TradeHistoryDownload: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object
) => {
  return API.auth_request("GET", "Equity/FileCsv/TradeHistoryDownload", params)
}

const GetShikiho: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetShikiho",
    params,
    headers
  )
}

/**
 * 株価分析情報
 */
const GetStockPriceAnalysis: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetStockPriceAnalysis",
    params,
    headers
  )
}

/**
 * 投資部門別売買状況（直近）
 */
const GetInvestorTradeValue: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetInvestorTradeValue",
    params,
    headers
  )
}

/**
 * 投資部門別売買状況（過去）
 */
const GetTradingValueByInvestorTypeRatio: API.RequestAPI<
  APIResponse.Res | {}
> = async (params?: object, headers?: object) => {
  return await API.auth_request(
    "GET",
    "Equity/Message/GetTradingValueByInvestorTypeRatio",
    params,
    headers
  )
}

export default {
  Ranking,
  SymbolSheetList,
  SymbolSheet,
  GetRealSymbolSheetList,
  EditSymbolSheet,
  RegisterTriggerMail,
  GetTriggerMail,
  CancelTriggerMail,
  Screening,
  StockholderBenefit,
  DivisionStatistics,
  DivisionChangedRatio,
  NewPriceSymbol,
  SpecialQuoteSymbol,
  GetTheme,
  GetThemeSymbolList,
  SearchSymbolKeywords,
  GetSSOUrl,
  SpecificAccountPLDetailDownload,
  TradeHistoryDownload,
  GetShikiho,
  GetStockPriceAnalysis,
  GetInvestorTradeValue,
  GetTradingValueByInvestorTypeRatio,
}
